import React from 'react';
import styled from 'styled-components';
import { Stack } from '@mui/material';
import oligoLogo from '../../resource/oligo-logo.svg';
import xeroLogo from '../../resource/xero/Xero Wordmark Blue.png';

const OLIGO_LOGO_HEIGHT = '56px';
const XERO_LOGO_HEIGHT = '45px';
const DIVIDER_HEIGHT = '40px';
const NARROW_SCREEN = '480px';
const NARROW_SCALE = 0.75;

const scaleDown = (size) => `calc(${size} * ${NARROW_SCALE})`;

const Logo = styled.img`
  display: block;
  height: ${({ $height }) => $height};
  width: auto;

  @media (max-width: ${NARROW_SCREEN}) {
    height: ${({ $height }) => scaleDown($height)};
  }
`;

const Divider = styled.span`
  width: 1px;
  height: ${DIVIDER_HEIGHT};
  background-color: #ccc;

  @media (max-width: ${NARROW_SCREEN}) {
    height: ${scaleDown(DIVIDER_HEIGHT)};
  }
`;

export const XeroAuthHeader = () => (
  <Stack direction="row" alignItems="center" justifyContent="center" gap="20px">
    <Logo src={oligoLogo} alt="Oligo" $height={OLIGO_LOGO_HEIGHT} />
    <Divider />
    <Logo src={xeroLogo} alt="Xero" $height={XERO_LOGO_HEIGHT} />
  </Stack>
);
